<template>
  <div class="main">
    <div class="steps clearfix text-center">
      <Logo />
    </div>
    <div class="container">
      <h2>create an account</h2>
      <p class="text-center">
        Do you need any help?&nbsp;<a
          href=""
          data-target="#helpModal"
          data-toggle="modal"
          >Get in touch
        </a>
      </p>
      <form
        method="POST"
        id="signup-form"
        class="signup-form wizard clearfix"
        novalidate="novalidate"
        autocomplete="off"
      >
        <div class="steps clearfix">
          <ul ref="steps" role="tablist">
            <li
              role="tab"
              :class="{ current: tab.isActive }"
              :aria-disabled="!tab.isActive"
              :aria-selected="tab.isActive"
              v-for="tab in tabs"
              :key="tab.name"
            >
              <a
                ><span class="current-info audible"> </span
                ><span class="title">
                  <span class="icon"><i :class="tab.icon"></i></span>
                  <span class="title_text">{{ tab.name }}</span>
                </span></a
              >
            </li>
          </ul>
        </div>
        <div class="content clearfix">
          <div class="tab-content">
            <About v-if="currentActive == 0 && !showTwoFa" />
            <Preference v-else-if="currentActive == 1" />
            <Address v-else-if="currentActive == 2" />
            <Identity v-else-if="currentActive == 3" />
            <AntiSpamTwoFa v-if="showTwoFa" />
          </div>
          <div class="col-sm-12 p-0 " v-if="!actions.hideNavigation">
            <message-info />
          </div>

          <div
            class="wizard-footer height-wizard mt-3"
            v-if="!actions.hideNavigation"
          >
            <div class="pull-right">
              <input
                type="button"
                class="btn btn-next btn-fill btn-success btn-wd btn-md"
                name="next"
                value="Next"
                @click="next()"
              />
            </div>
            <div class="pull-left" v-if="currentActive > 0">
              <input
                type="button"
                class="btn btn-previous btn-fill btn-default btn-wd btn-md"
                name="previous"
                value="Previous"
                @click="prev()"
              />
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="col-sm-12 mt-2" v-if="!actions.hideNavigation">
            <hr />
            <privacy-policy />
          </div>
        </div>
      </form>
      <Loading v-if="loading" />
      <!-- end row -->
    </div>
    <!--  big container -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Common } from "@/helper/common";
import MessageInfo from "@/components/ui/MessageInfo.vue";
import About from "@/components/steps/About.vue";
import moment from "moment";
import Address from "@/components/steps/Address.vue";
import Identity from "@/components/steps/Identity.vue";
import Preference from "@/components/steps/Preference.vue";
import Loading from "@/components/ui/Loading.vue";
import axios from "axios";
import mixin from "@/components/shared/mixinUtility";
import Logo from "@/components/ui/Logo.vue";
import PrivacyPolicy from "@/components/ui/PrivacyPolicy.vue";
import AntiSpamTwoFa from "@/components/verification/VerifyTwoFaAntispam.vue";

export default {
  name: "form-wizard",
  mixins: [mixin],
  data() {
    return {
      loading: false,
      existingClients: [211, 215, 216, 217, 218, 219, 220],
      showTwoFa: false,
    };
  },
  computed: {
    ...mapGetters({
      tabs: "getTabs",
      currentActive: "getCurrentActive",
      totalTabs: "getTotalTabs",
      actions: "getActions",
      formData: "getFormData",
      contactId: "getContactId",
      mainContactId: "getMainContactId",
      jwtToken: "getJwtToken",
      showAntiSpam: "getAntiSpam",
    }),
  },
  components: {
    "message-info": MessageInfo,
    About,
    Address,
    Identity,
    Preference,
    Loading,
    Logo,
    "privacy-policy": PrivacyPolicy,
    AntiSpamTwoFa,
  },
  methods: {
    next() {
      //reset messageinfo
      this.resetMessageInfo();
      this.$root.$validator
        .validate("step" + (this.currentActive + 1) + ".*")
        .then(async (valid) => {
          if (valid) {
            try {
              if (this.currentActive == 0) {
                //validate mobile number
                let isValidNumber = await this.isValidMobileNumber();
                if (!isValidNumber) {
                  this.showGenericErrorMessage(
                    "Please enter a valid mobile number.",
                    false
                  );
                  return false;
                }

                //## STEP 1 ## Check existing client
                await this.firstStep();
              } else if (this.currentActive == 1) {
                //## STEP 2 ## prefences
                //this.goNext();
                await this.savePreferences();
              } else if (this.currentActive == 2) {
                //## STEP 3 ## Address info
                await this.secondStep();
              } else if (this.currentActive == 3) {
                //## STEP 4 ## Id upload
                this.goNext();
              }
            
              //for final step
              if (this.currentActive == this.totalTabs - 1) {
                this.$store.dispatch("setFinalStep", true);
              }
            } catch (ex) {
              console.log(ex);
              //show some error
              this.showGenericErrorMessage(
                "We've encountered a problem.",
                false
              );
              this.loading = false;
            }
          } else {
            //form not valid
            this.showGenericErrorMessage(
              "Please enter all mandatory fields.",
              false
            );
          }
        });
    },
    goNext() {
      this.$store.dispatch("setCurrentActive", this.currentActive + 1);
      this.tabs.forEach((tab) => {
        tab.isActive = false;
      });

      this.tabs[this.currentActive].isActive = true;
      Common.scrollBackUp();
      this.resetMessageInfo();
    },
    prev() {
      //reset messageinfo
      this.resetMessageInfo();
      this.$store.dispatch("setCurrentActive", this.currentActive - 1);
      this.$store.dispatch("setFinalStep", false);
      this.tabs.forEach((tab) => {
        tab.isActive = false;
      });
      this.tabs[this.currentActive].isActive = true;
      Common.scrollBackUp();
    },
    customValidationForDob() {
      this.$validator.extend("minage", {
        // eslint-disable-next-line
        getMessage(field, val) {
          return "must be 18+";
        },
        // eslint-disable-next-line
        validate(value, field) {
          // eslint-disable-next-line
          var date = moment(value, "DD/MM/YYYY");
          if (date.isValid()) {
            var userDate = new Date(
              date.year() + 18,
              date.month(),
              date.date()
            );
            return userDate <= new Date();
          } else {
            return false;
          }
        },
      });
    },
    async firstStep() {
      this.loading = true;
      const resExistingContact = await this.checkContact();
      this.logApi({
        request: { email: this.formData.email },
        response: { data: resExistingContact.data },
      });
      //set token
      if (resExistingContact.data.token)
        await this.$store.dispatch(
          "setJwtToken",
          resExistingContact.data.token.access_token
        );
      //new client
      if (!resExistingContact.data.IsContactExists) {
        this.$store.dispatch("setContactExist", false);

        //do 2fa here
        if (this.showAntiSpam) {
          const codeRes = await this.sendCodeToMobileAntiSpam();
          // Check if the request was blocked due to 400 error
          if (codeRes && codeRes.blocked) {
            this.loading = false;
            return false;
          }
          //update message
          this.$store.dispatch("twoFaMessage", codeRes);
          this.showTwoFa = true;
          this.loading = false;
          //show 2fa verify box
          return false;
        }
        //create contact
        let resContact = await this.createContact(true);
        this.loading = false;

        if (resContact.data.status == 0) {
          this.showGenericErrorMessage("We've encountered a problem.", false);
          return false;
        }
        //set contactId
        this.$store.dispatch("setContactId", resContact.data.contactId);
        this.$store.dispatch("setMainContactId", resContact.data.maincontactId);
        //set token
        if (resContact.data.token)
          await this.$store.dispatch(
            "setJwtToken",
            resContact.data.token.access_token
          );
        this.goNext();
      } else {
        //apply some rules
        if (
          this.existingClients.find(
            (ex) => ex == resExistingContact.data.StatusId
          )
        )
          //redirect user to existing page
          this.$router.push({ name: "Existing" });
        else {
          //existing but not active client
          this.$store.dispatch(
            "setContactId",
            resExistingContact.data.ContactId
          );
          //set maincontactId
          this.$store.dispatch(
            "setMainContactId",
            resExistingContact.data.MainContactId
          );
          this.$store.dispatch("setContactExist", true);

          //do 2fa here
          if (this.showAntiSpam) {
            const codeRes = await this.sendCodeToMobileAntiSpam();
            // Check if the request was blocked due to 400 error
            if (codeRes && codeRes.blocked) {
              this.loading = false;
              return false;
            }
            //update message
            this.$store.dispatch("twoFaMessage", codeRes);
            this.showTwoFa = true;
            this.loading = false;
            //show 2fa verify box
            return false;
          }
          //create contact
          let resContact = await this.createContact(true);

          this.loading = false;

          if (resContact.data.status == 0) {
            this.showGenericErrorMessage("We've encountered a problem.", false);
            return false;
          }
          //set contactId
          this.$store.dispatch("setContactId", resContact.data.contactId);
          this.$store.dispatch(
            "setMainContactId",
            resContact.data.maincontactId
          );
          //set token
          if (resContact.data.token)
            await this.$store.dispatch(
              "setJwtToken",
              resContact.data.token.access_token
            );
          this.goNext();
        }
      }
    },
    async secondStep() {
      //check if they accepted t&c
      if (!this.formData.terms) {
        this.showGenericErrorMessage(
          "Please accept terms and conditions.",
          false
        );
      } else {
        //we are ready to create/update a new contact
        this.loading = true;
        try {
          const resContact = await this.createContact(false);
          this.loading = false;

          if (resContact.data.status == 0) {
            this.showGenericErrorMessage("We've encountered a problem.", false);
            return false;
          } else {
            //set cookies - tracking
            Common.setCookie("email", this.formData.email, 30);
            Common.setCookie("firstname", this.formData.firstName, 30);
            Common.setCookie("lastname", this.formData.lastName, 30);
            //set contactId
            this.$store.dispatch("setContactId", resContact.data.contactId);
            this.$store.dispatch(
              "setMainContactId",
              resContact.data.maincontactId
            );
            //set token
            if (resContact.data.token)
              await this.$store.dispatch(
                "setJwtToken",
                resContact.data.token.access_token
              );
            //check if any additional user
            if (resContact.data.additionalUserIds) {
              let addUserIds = resContact.data.additionalUserIds.split(",");
              if (addUserIds.length > 0)
                this.$store.dispatch(
                  "setAdditionalContactId",
                  parseInt(addUserIds[0])
                );
            }
            //set datadog user
            this.setDatadogUser(resContact.data.contactId, this.formData.email);
            //do gbg checks in here
            this.doGBGChecks();
            //only if antispam is off
            if (!this.showAntiSpam) {
              //send 2fa code
              const twoFaResponse = await this.sendCodeToMobile(this.contactId);
              //show mobile verification
              this.$store.dispatch("showHideMobileVerification", {
                show: true,
                message: twoFaResponse,
              });
            }else
            {
              //show callback at this point? ######
              this.$store.dispatch("showCallback", true);
            }
          }
        } catch (ex) {
          //show some error
          this.showGenericErrorMessage("We've encountered a problem.", false);
          this.loading = false;
        }
      }
    },
    async savePreferences() {
      this.resetMessageInfo();
      this.$root.$validator
        .validate("step" + (this.currentActive + 1) + ".*")
        .then(async (valid) => {
          if (valid) {
            //check for source/target currency
            if (this.formData.sourceCurrency == this.formData.targetCurrency) {
              this.showGenericErrorMessage(
                "Source/Target Currency can't be the same.",
                false
              );
              return false;
            }
            this.loading = true;
            const data = await this.confirmDetails();
            if (data.status.toLowerCase() == "ok") {
              this.loading = false;
              this.goNext();
            } else {
              this.showGenericErrorMessage(
                "We've encountered a problem.",
                false
              );
              this.loading = false;
              this.logApi({
                request: {
                  error: "ERROR - CONFIRM DETAILS",
                  email: this.formData.email,
                },
                response: { data: data },
              });
            }

            //all valid?
          } else {
            //not valid
            this.showGenericErrorMessage(
              "Please enter all mandatory fields.",
              false
            );
          }
        });
    },
    async confirmDetails() {
      const payload = {
        contactId: this.contactId,
        countryId: parseInt(this.formData.transferDestination.CountryId),
        sourceCurrency: this.formData.sourceCurrency.CurrencyCode,
        targetCurrency: this.formData.targetCurrency.CurrencyCode,
        targetAmount: parseFloat(this.formData.transferAmount),
        reasonForTransferId: parseInt(this.formData.reasonForTransfer),
        sourceSite: this.formData.sourceSiteForPreference,
        referralSource: this.formData.referralSource,
        referralEmployeeId: this.formData.referredByEmpId,
        referrerById: this.formData.referredBy,
        referredByEmail: this.formData.referredByEmail,
        bizId: this.formData.bizId,
        isContactExist: this.formData.isContactExist,
      };

      const { data } = await axios.post(
        process.env.VUE_APP_API_URL + "/client/ConfirmDetails",
        payload,
        { headers: { Authorization: `Bearer ${this.jwtToken}` } }
      );

      return data;
    },
    async checkContact() {
      try {
        let formData = this.formData;
        //captcha
        // eslint-disable-next-line
        //grecaptcha.ready(function() {
        // eslint-disable-next-line
        const token = await grecaptcha.execute(
          "6LcgTAscAAAAALm_k6sF6J1pr1Eecw0FwnjRbuzm",
          { action: "submit" }
        );
        // eslint-disable-next-line
        if (document.querySelector(".g-recaptcha-response"))
          document.querySelector(".g-recaptcha-response").value = token;
        const { data } = await axios.get(
          process.env.VUE_APP_API_URL +
            "/client/contactAlreadyExists?email=" +
            formData.email +
            "&clientType=" +
            formData.clientType +
            "&bizID=" +
            formData.bizId,
          { headers: { token: token } }
        );
        return data;
        // });
      } catch (ex) {
        console.log("captcha", ex);
      }
    },
    logApi(payload) {
      try {
        axios.post(process.env.VUE_APP_API_URL + "/Log/SaveLogs", payload);
      } catch (ex) {
        console.log(ex);
      }
    },
    async createContact(firstStep) {
      const payload = firstStep
        ? {
            titleId: parseInt(this.formData.title),
            firstName: this.formData.firstName,
            lastName: this.formData.lastName,
            email: this.formData.email,
            mobileNumber: this.formData.mobilePrefix + this.formData.mobile,
            sourceSite: this.formData.sourceSite,
            referrerById: this.formData.referredBy,
            referralSourceId: this.formData.referralSource,
            referralEmployeeId: this.formData.referredByEmpId,
            gaTracking: decodeURIComponent(this.formData.gaTracking),
            bizId: this.formData.bizId,
            acceptTnc: false,
          }
        : {
            titleId: parseInt(this.formData.title),
            firstName: this.formData.firstName,
            lastName: this.formData.lastName,
            email: this.formData.email,
            dateOfBirth: this.formData.dob,
            mobileNumber: this.formData.mobilePrefix + this.formData.mobile,
            telNumber: this.formData.telPrefix + this.formData.telephone,
            address:
              parseInt(this.formData.country.CountryId) == 225
                ? ""
                : this.formData.addressLine,
            buildingNameNo: this.formData.buildingNo,
            postCode: this.formData.postCode,
            city: this.formData.city,
            countryId: parseInt(this.formData.country.CountryId),
            postcodeAnywhereId: this.formData.postcodeAnywhereId,
            street:
              parseInt(this.formData.country.CountryId) == 225
                ? this.formData.addressLine
                : "",
            district: this.formData.district,
            countyState: this.formData.countyState,
            useDetails: parseInt(this.formData.country.CountryId) == 225,
            sourceSite: this.formData.sourceSite,
            referrerById: this.formData.referredBy,
            referralSourceId: this.formData.referralSource,
            referralEmployeeId: this.formData.referredByEmpId,
            gaTracking: decodeURIComponent(this.formData.gaTracking),
            bizId: this.formData.bizId,
            acceptTnc: true,
          };

      //check for additional user
      if (this.formData.jointAccount == "yes") {
        payload.additionalUsers = [
          {
            titleId: parseInt(this.formData.titleAdditional),
            firstName: this.formData.firstNameAdditional,
            lastName: this.formData.lastNameAdditional,
            isEmailAddressSameAsMainApplicant:
              this.formData.emailAdditional == this.formData.email,
            email: this.formData.emailAdditional,
            dateOfBirth: this.formData.dobAdditional,
            isAddressSameAsMainApplicant: this.formData.sameAddressAsMain,
            buildingNameNo: this.formData.buildingNoAdditional,
            address:
              (this.formData.sameAddressAsMain &&
                parseInt(this.formData.country.CountryId) == 225) ||
              parseInt(this.formData.countryAdditional.CountryId) == 225
                ? ""
                : this.formData.addressLineAdditional,
            city: this.formData.cityAdditional,
            countryId: this.formData.sameAddressAsMain
              ? 0
              : parseInt(this.formData.countryAdditional.CountryId),
            postcodeAnywhereId: this.formData.postcodeAnywhereIdAdditional,
            street:
              (this.formData.sameAddressAsMain &&
                parseInt(this.formData.country.CountryId) == 225) ||
              parseInt(this.formData.countryAdditional.CountryId) == 225
                ? this.formData.addressLineAdditional
                : "",
            district: this.formData.districtAdditional,
            countyState: this.formData.countyStateAdditional,
            useDetails:
              (this.formData.sameAddressAsMain &&
                parseInt(this.formData.country.CountryId) == 225) ||
              (!this.formData.sameAddressAsMain &&
                parseInt(this.formData.countryAdditional.CountryId) == 225),
            postcode: this.formData.postCodeAdditional,
          },
        ];
      }

      if (this.contactId) {
        payload.contactId = this.contactId;
        payload.mainContactId = this.mainContactId;
      }

      const { data } = this.contactId
        ? await axios.put(
            process.env.VUE_APP_API_URL + "/client/UpdateContact",
            payload,
            { headers: { Authorization: `Bearer ${this.jwtToken}` } }
          )
        : await axios.post(
            process.env.VUE_APP_API_URL + "/client/CreateContact",
            payload,
            { headers: { Authorization: `Bearer ${this.jwtToken}` } }
          );

      return data;
    },
    async getCountryCodes() {
      const res = await axios.get(
        process.env.VUE_APP_API_URL + "/client/countryCodeList"
      );
      this.$store.dispatch("setCountryCodes", res.data.data);
    },
    async isValidMobileNumber() {
      let isValid = false;
      try {
        let formData = this.formData;
        //clean prefix
        let prefix =
          formData.mobilePrefix.indexOf("|") > -1
            ? formData.mobilePrefix.split("|")[1]
            : formData.mobilePrefix;
        const phoneNumber = prefix + formData.mobile;
        const { data } = await axios.post(
          process.env.VUE_APP_API_URL +
            "/client/ValidatePhoneNumber?phone=" +
            phoneNumber
        );
        isValid = data.isValid;
        return isValid;
      } catch (ex) {
        console.log("mobile validation error", ex);
        return false;
      }
    },
  },
  mounted() {
    this.$store.dispatch("setTotalTabs", this.tabs.length);
  },
  async created() {
    //custome validation for dob
    this.customValidationForDob();
    this.loading = true;
    await this.getCountryCodes();
    this.loading = false;
  },
};
</script>
